import React, { Component } from 'react'
import { Spin } from 'antd'

class Loading extends Component {

    render() {
        return (
            <div>A carregar... <Spin /></div>
        )
    }
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading.js